var data = {
	"body": "<g fill=\"none\"><path d=\"M4 3a2 2 0 0 0-2 2v.201l6 3.231l6-3.23V5a2 2 0 0 0-2-2H4z\" fill=\"currentColor\"/><path d=\"M14 6.337L8.237 9.44a.5.5 0 0 1-.474 0L2 6.337V11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.337z\" fill=\"currentColor\"/></g>",
	"width": 16,
	"height": 16
};
exports.__esModule = true;
exports.default = data;
